/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from 'react';
import { useEffect } from 'react';
import {
  InputGroup,
  ListGroup,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import './ProjectSearchInput.css'; 


const ProjectsSearchInput = ({
  selectedProject, 
  setSelectedProject, 
  label='Proyecto',
  width = "auto",
  required = false
}) => {
  const {
    projectsByCompanies,
    projectsByCompaniesLoading,
  } = useSelector((state) => state.cashFlow);
  
  const [searchTerm, setSearchTerm] = useState('');
  const [showResults, setShowResults] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const inputRef = useRef(null);
  const resultsRef = useRef(null);

  const wrapperStyle = {
    width: width
  };

  const filteredProjects = searchTerm.length > 0 
    ? projectsByCompanies.filter(project =>
        project?.CodProyectoVector?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project?.CodProyecto?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project?.Descripcion?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : projectsByCompanies;

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setShowResults(true);
  };

  const handleSelectProject = (project) => {
    setSelectedProject(project.CodProyecto || project.CodProyectoVector);
    setSearchTerm(project.Descripcion);
    setShowResults(false);
    setHasFocus(false);
  };

  const handleInputFocus = () => {
    setHasFocus(true);
    setShowResults(true);
  };

  const handleInputBlur = (e) => {
    if (resultsRef.current && resultsRef.current.contains(e.relatedTarget)) {
      return;
    }
    
    setHasFocus(false);
    setTimeout(() => {
      if (!hasFocus) {
        setShowResults(false);
      }
    }, 200);
  };

  const handleClearSelection = () => {
    setSelectedProject('');
    setSearchTerm('');
    setShowResults(true);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    handleClearSelection()
  }, [projectsByCompaniesLoading, projectsByCompanies])

  const shouldShowResults = showResults && 
                           !projectsByCompaniesLoading && 
                           (hasFocus || searchTerm.length > 0) &&
                           selectedProject === '';

  return (
    <div 
      className={`material-select-wrapper ${(hasFocus || searchTerm || selectedProject) ? 'focused' : ''}`}
      style={wrapperStyle}
    >
      <label className="material-select-label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
      
      <div className="position-relative">
        <InputGroup ref={inputRef}>
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            placeholder={projectsByCompaniesLoading ? "Cargando..." : "Buscar por código o descripción"}
            disabled={projectsByCompaniesLoading || projectsByCompanies.length === 0}
            className="form-control material-select search-input"
            style={{
              paddingRight: selectedProject ? '2.5rem' : '0.75rem'
            }}
          />
          {selectedProject && (
            <InputGroup.Text 
              style={{ 
                cursor: 'pointer',
                position: 'absolute',
                right: '0',
                zIndex: 10,
                backgroundColor: 'transparent',
                border: 'none',
                height: '100%',
                display: 'flex',
                alignItems: 'center'
              }}
              onClick={handleClearSelection}
              title="Limpiar selección"
            >
              ×
            </InputGroup.Text>
          )}
        </InputGroup>
        
        {shouldShowResults && (
          <div 
            ref={resultsRef}
            className="search-results-container"
            onMouseDown={(e) => e.preventDefault()}
          >
            <ListGroup variant="flush" className="search-results">
              {filteredProjects.length > 0 ? (
                <>
                  <ListGroup.Item className="py-2 small text-muted">
                    {searchTerm.length > 0 
                      ? `${filteredProjects.length} resultado(s) encontrado(s)` 
                      : `${filteredProjects.length} proyecto(s) disponible(s)`}
                  </ListGroup.Item>
                  {filteredProjects.map((project) => (
                    <ListGroup.Item
                      key={project.CodProyecto || project.CodProyectoVector}
                      action
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => handleSelectProject(project)}
                      active={selectedProject === project.CodProyecto || selectedProject === project.CodProyectoVector}
                      className="py-2"
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="d-flex flex-column">
                        <span className="fw-bold small">{project.CodProyecto || selectedProject === project.CodProyectoVector}-{project.Descripcion}</span>
                      </div>
                    </ListGroup.Item>
                  ))}
                </>
              ) : (
                <></>
                // <ListGroup.Item className="py-2 text-muted fst-italic">
                //   No se encontraron proyectos
                // </ListGroup.Item>
              )}
            </ListGroup>
          </div>
        )}
      </div>
      
      {/* {!projectsByCompaniesLoading && projectsByCompanies.length === 0 && (
        <Alert variant="warning" className="mt-2 small py-2">
          No hay proyectos disponibles
        </Alert>
      )} */}
    </div>
  );
};

export default ProjectsSearchInput;